import { useQuery } from "@tanstack/react-query";
import { getTopscorer } from "../openapi/api-client.ts";

export const useTopscorer = (competitionId?: string) => {
  return useQuery({
    queryKey: ["topscorer", { competitionId }],
    enabled: !!competitionId,
    queryFn: async () => {
      if (!competitionId) {
        throw new Error("competitionId not set");
      }

      const topscorer = await getTopscorer({ competitionId });
      return topscorer.data;
    },
  });
};
